import { type RouteObject } from 'react-router'

import {
  PDP_DETAIL_TRANSACTION_PATH,
  PDP_DETAIL_URL,
  PDP_TRANSACTION_PATH,
  PDP_URL,
} from 'features/pdp/paths'
import { lazyDefault } from 'routes/lazy-route'

// A factory, not a hoisted const — react-router mutates a `lazy` object while
// resolving it, so two routes sharing one object silently break the second.
const pdpPage = (): ReturnType<typeof lazyDefault> =>
  lazyDefault(() => import('features/pdp/Container'))

export const pdpRoutes: RouteObject[] = [
  {
    path: PDP_URL,
    lazy: pdpPage(),
    handle: {
      featureKey: PDP_URL,
      sentryTransactionPath: PDP_TRANSACTION_PATH,
    },
  },
  {
    path: `${PDP_URL}/:product`,
    lazy: pdpPage(),
    handle: {
      featureKey: PDP_DETAIL_URL,
      sentryTransactionPath: PDP_DETAIL_TRANSACTION_PATH,
    },
  },
]
